module.exports = __webpack_public_path__ + "img/image (1).8300292e.png";